import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from "@mui/material";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useState } from "react";
import swal from 'sweetalert';
import { useDispatch, useSelector } from "react-redux";
import ShowLibraryReference from "./ShowLibraryReference";
import { getChecklistData } from "../../services/api/StandAlone/disclosureChecklist";
import LoaderTwo from "../Common/Loader/LoaderTwo";
import { socket } from '../../services/socket/socket';
import "./DisclouserChecklist.css";
import "../../WorkSpace/font.css";
import Loader from "../../helper/loader";
import { act } from "react";


///////////////////////////////////////////////////////
import bookclosuretablecss from "../../myfin_v2/css/pnltable.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`vertical-tabpanel-${index}`}
          aria-labelledby={`vertical-tab-${index}`}
          {...other}
      >
          {value === index && (
              <Box p={0}>
                  <Typography>{children}</Typography>
              </Box>
          )}
      </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
const useStyles = makeStyles((theme) => ({
  root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      minHeight: '50vh',
  },
  tabs: {
      maxHeight: '100vh',
      borderRight: `1px solid ${theme.palette.divider}`,
      background: 'linear-gradient(45deg, transparent, #E5EEEE)',
      color: 'black',
      fontSize: '2rem',
      width: '260px',
  },
  tab: {
      fontSize: '1rem',
      padding: '12px 12px',
      overflow: 'hidden',
      position: 'relative',
      fontSize: '1rem',
      boxSizing: 'border-box',
      minHeight: '55px',
      textAlign: 'center',
      flexShrink: 0,
      fontWeight: "500",
      lineHeight: '1.75',
      letterSpacing: '0.02857em',
      textTransform: 'none',
  },
  TabPanel: {
      width: '100%'
  },
}));

// const DisclosuresChecklist = ({setDisclosuresChecklistSubMenu},activeTabDisclosureCheckList) => {
  const DisclosuresChecklist = ({ setDisclosuresChecklistSubMenu, activeTabDisclosureCheckList }) => {
  const classes = useStyles();
  const project_id = localStorage.getItem('project_id');
  const user = JSON.parse(localStorage.getItem('user'));
  const tb_id = localStorage.getItem("tb_id");
  const dispatch = useDispatch();
  const [checklist, setChecklist] = useState([]);
  const [isShowRef, setIsShowRef] = useState({ isShow: false, data: [] });
  const [loading, setLoading] = useState(false);
  // console.log(activeTabDisclosureCheckList, "activeTabDisclosureCheckList");
  const { 
    disclosureChecklistData, 
    noteIndex
  } = useSelector((initialState) => initialState.DisclosureChecklistReducer);

  useEffect(() => {
    setLoading(true);
    getChecklistData(project_id, tb_id).then(response => {
      dispatch({ type: "DISCLOSURE_CHECKLIST_DATA", payload: response?.data?.data });
      setChecklist(response?.data?.data);
    }).catch(error => {
      swal("Error", error.response?.data?.error, "error");
    }).finally(() => setLoading(false))
  }, []);

   useEffect(() => { 
    if (setDisclosuresChecklistSubMenu) {
      setDisclosuresChecklistSubMenu(checklist);  
    }
  }, [checklist]);

  const FilterLibRef = (reference) => {
    setIsShowRef({ ...isShowRef, data: reference, isShow: true });
  };

  const HandleRemarkChange = (e, checklist_index, dis_index) => {
    const {name, value} = e.target;
    const copy_checklist = [...checklist];

    if (
      copy_checklist[checklist_index] &&
      copy_checklist[checklist_index].disclosure &&
      copy_checklist[checklist_index].disclosure[dis_index]
    ) {
      if(name === "value"){
        if(!copy_checklist[checklist_index].disclosure[dis_index]?.isManual) return;
      }
      copy_checklist[checklist_index].disclosure[dis_index][name] = value;
    }

    setChecklist(copy_checklist);

    // Socked code for update and error handeling
    socket.emit("auto-save-disclosure-checklist", {
      project_id: `${project_id}`,
      contents: copy_checklist,
    });
    socket.on('auto-save-disclosure-checklist', (data) => {
      if(!data.success){
        swal("Error", data.message, "error");
      }
    });
  };

  return (
    <>
      {loading ? <Loader /> :
        <div className={classes.root}>
          {/* <Tabs
            orientation="vertical"
            variant="scrollable"
            value={noteIndex}
            onChange={(event, newValue) => dispatch({ type: "NOTE_INDEX", payload: newValue }) }
            aria-label="Vertical tabs example"
            className={classes.tabs}
            TabIndicatorProps={{ style: { backgroundColor: '#03565A',width:"3px" } }}
          >
            {
              checklist && checklist.length > 0 && checklist.map((item, ix) =>(
                <Tab key={ix} className={`${classes.tab} font-sans`} style={{ color: "black", fontWeight: "600" }} label={item?.name} {...a11yProps(ix)} />
              ))
            }
          </Tabs> */}

          {
            checklist && checklist.length > 0 && checklist?.map((cat, cx) => (
              <TabPanel key={cx} className={classes.TabPanel} value={noteIndex} index={cx} style={{maxHeight:"52rem", overflowY:"scroll",paddingLeft: "25px",paddingRight: "10px"}} >
                <table className={`${bookclosuretablecss.bookClosureTable} ${tablecss.brTable}`} style={{ marginBottom: "1rem",marginTop: "1rem" }}>
                  <thead  >
                    <tr>
                      <th className="font-sans" style={{width: "15%"}}>Paragraph reference</th>
                      <th className="font-sans" style={{width: "40%", textAlign: "center"}} >Disclosure</th>
                      <th className="font-sans" style={{width: "8%", textAlign: "right"}}>Yes</th>
                      <th className="font-sans" style={{width: "8%", textAlign: "right"}}>No</th>
                      <th className="font-sans" style={{width: "8%", textAlign: "right"}}>NA</th>
                      <th className="font-sans" style={{textAlign: "center"}}>REMARKS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cat.disclosure.map((dis, dx) => (
                        <tr key={dx} className={dis?.isManual && "bg-warning-100"}>
                          <td className="fs-inter p-table text-left pl-2 cursor-pointer" style={{fontSize: "14px", color: "#111111", fontFamily: "DM Sans"}} onClick={() => FilterLibRef(dis)} >{dis?.reference}</td>
                          <td>
                            <h6 className="p-secondtable " style={{fontSize: "14px", color: "#111111", fontFamily: "DM Sans", fontWeight: "400"}}>
                              {dis?.notes}
                            </h6>
                          </td>
                          <td style={{textAlign: "right"}}>
                            <input 
                              type="checkbox" 
                              checked={dis?.value === "yes"}
                              value="yes" 
                              disabled={user.responsibilities === "view"||user.responsibilities === "approver"}
                              name="value"
                              onChange={(e) => HandleRemarkChange(e,cx,dx)}
                            />
                          </td>
                          <td style={{textAlign: "right"}}>
                            <input 
                              type="checkbox" 
                              checked={dis?.value === "no"}
                              value="no" 
                              disabled={user.responsibilities === "view"||user.responsibilities === "approver"}
                              name="value"
                              onChange={(e) => HandleRemarkChange(e,cx,dx)}
                            />
                          </td>
                          <td style={{textAlign: "right"}}>
                            <input 
                              type="checkbox" 
                              checked={dis?.value === "na"}
                              value="na"
                              disabled={user.responsibilities === "view"||user.responsibilities === "approver"}
                              name="value"
                              onChange={(e) => HandleRemarkChange(e,cx,dx)}
                            />
                          </td>
                          <td style={{textAlign: "center"}}>
                            <input 
                              // className={`h-100 border-0 px-1 font-sans ${dis?.isManual && "bg-warning-100"}`}
                              className={`h-100 border-0 px-1 font-sans ${dis?.isManual && "bg-warning-100"}`}
                              placeholder="add remark"
                              name="remark"
                              value={dis?.remark}
                              disabled={user.responsibilities === "view"||user.responsibilities === "approver"}
                              onChange={(e) => HandleRemarkChange(e,cx,dx)}
                              style={{textAlign: "center"}}
                            />
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </TabPanel>
            ))
          }
        </div>
      }
      <ShowLibraryReference isShowRef={isShowRef} setIsShowRef={setIsShowRef} />
      
    </>
  );
};

export default DisclosuresChecklist;